import React, {Fragment} from 'react';
import { Link } from 'react-router-dom';
import { db } from 'lib/firebase';
import { getDoc, doc, collection, getDocs } from 'firebase/firestore';

import { useEffect, useState } from 'react';
import { prettyPrint } from '../../views/inner-pages/blog/SiblingNewsletterPage';
import { Skeleton } from '@mui/material';

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
]

export const useAllYearsData = () => {
    const [yearsData, setYearsData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        const getData = async () => {
            try {
                const yearsCollection = collection(db, "SiblingNewsletter");
                const yearsSnapshot = await getDocs(yearsCollection);
                
                const yearsPromises = yearsSnapshot.docs.map(async (yearDoc) => {
                    const year = yearDoc.id;
                    
                    // Return counts from each month query
                    const monthsPromises = months.map(async (month) => {
                        const monthCollection = collection(db, "SiblingNewsletter", year, month);
                        const monthSnapshot = await getDocs(monthCollection);
                        
                        let monthCount = 0;
                        monthSnapshot.forEach((doc) => {
                            const data = doc.data();
                            if (data.text && data.text.length > 0) {
                                monthCount++;
                            }
                        });
                        return monthCount;
                    });
                    
                    // Wait for all month queries and sum the counts
                    const monthCounts = await Promise.all(monthsPromises);
                    const count = monthCounts.reduce((sum, c) => sum + c, 0);
                    
                    return { year, count };
                });

                const results = await Promise.all(yearsPromises);
                // Sort by year descending
                results.sort((a, b) => b.year - a.year);
                
                if (mounted) {
                    setYearsData(results);
                    setLoading(false);
                }
            } catch (error) {
                if (mounted) setLoading(false);
            }
        };

        getData();
        return () => mounted = false;
    }, []);

    return { data: yearsData, loading };
};

export const DynamicNewsletterLinks = (props) => {

  if (Object.keys(props.data).length === 0) {
    return (
      <Fragment >
        <Skeleton width = {200}/>
        <Skeleton width = {200}/>
        <Skeleton width = {200}/>
      </Fragment>
    )
  }
  
  return (
  <Fragment>
    <ul className="style-none">
      {Object.keys(props.data).map((key, index)=>{
        const path = `/newsletter/${props.year}/${key.toLowerCase()}`;
        return (<li key={index} className="category">
            <Link to={path}>{`${prettyPrint(key)}`} <span style={{fontWeight: "bold"}}>{`(${props.data[key]})`}</span></Link>
        </li>
      )}
      )}
    </ul>
  </Fragment>
  );
}

export const useNewsLetterData = (year="2023") => {
    const [newsletterData, setNewsletterData] = useState({});
  
    useEffect(() => {
      let mounted = true;
      const getNewsletterData = async() => {

        let results = {};
        const docSnapshot = await getDoc(doc(db, "SiblingNewsletter", year));
        if (docSnapshot.exists() && mounted) {  
            setNewsletterData(docSnapshot.data());
        }
      };
      getNewsletterData();
      return () => mounted = false;
    }, []);
    return newsletterData;
  }

const NewsletterLinks = () => {
  const { data, loading } = useAllYearsData();

  if (loading) {
      return (
          <Fragment>
              <Skeleton width={200} height={30} style={{marginBottom: 10}}/>
              <Skeleton width={200} height={30} style={{marginBottom: 10}}/>
              <Skeleton width={200} height={30} style={{marginBottom: 10}}/>
          </Fragment>
      );
  }

  return (
      <Fragment>
          <ul className="style-none">
            {data.map((val, i)=>(
                  <li key={i} className="category">
                  <Link to={`/newsletter/${val.year}`}>{val.year} <span>({val.count})</span></Link>
              </li>
            ))}
          </ul>
      </Fragment>
  )
}

export default NewsletterLinks